import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import { MdOutlineAccountBalanceWallet } from 'react-icons/md'
import CheckIcon from '@mui/icons-material/Check'
import defaultTexts from '../../../texts/texts'

const SubmitPaymentMethodBalance = (props) => {
  const { selectedPaymentMethod, handleSelectPaymentMethod } = props
  const theme = useTheme()

  const balanceWrapperStyle = {
    padding: '20px',
    background: theme.palette.violetsAreBlue,
    borderRadius: '20px',
    boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
    margin: '0px 20px',
    minHeight: '220px',
    cursor: 'pointer',
  }

  const balanceCheckboxStyle = {
    width: '30px',
    height: '30px',
    borderRadius: '10px',
    background: theme.palette.aliceBlue,
    color: theme.palette.violetsAreBlue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }

  const balanceTitleStyle = {
    color: 'white',
    fontSize: '32px',
    fontWeight: '600',
    fontStyle: 'italic',
  }

  return (
    <Box sx={balanceWrapperStyle} onClick={() => handleSelectPaymentMethod('balance')}>
      <Grid container spacing={1}>
        <Grid size={{ xs: 1 }}>
          <Box sx={balanceCheckboxStyle}>
            { selectedPaymentMethod === 'balance' && <CheckIcon sx={{ fontSize: '28px' }} /> }
          </Box>
        </Grid>
        <Grid size={{ xs: 11 }}>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='center'
            spacing={{ md: 1, lg: 3, xl: 6 }}
            sx={{ width: '100%', padding: '5% 0px' }}
          >
            <Box sx={{ color: 'white' }}>
              <MdOutlineAccountBalanceWallet size={90} />
            </Box>
            <Box sx={balanceTitleStyle}>{defaultTexts.payFromBalance}</Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubmitPaymentMethodBalance